'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const OspreyAcademyIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="OspreyAcademyIcon">
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_276_2416)">
          <path
            d="M12.45 10.6001L1.25 6.40009L12.45 2.1001L23.75 6.40009L12.45 10.6001Z"
            stroke={sx?.color || '#3D517B'}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M19.25 8.1001V13.5001C14.75 16.3001 10.25 16.3001 5.75 13.5001V8.1001"
            stroke={sx?.color || '#3D517B'}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.0498 7.1001V16.3001"
            stroke={sx?.color || '#3D517B'}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M4.85 18.1C4.85 17.1 4.05 16.3 3.05 16.3C2.05 16.3 1.25 17.1 1.25 18.1V21.9H4.85V18.1Z"
            stroke={sx?.color || '#3D517B'}
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_276_2416">
            <rect width="24" height="24" fill="white" transform="translate(0.5)" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

OspreyAcademyIcon.propTypes = {
  sx: PropTypes.object
}
